import { createRecordType } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { idValidator } from "../misc";
/** @public */ export const resourceIdValidator = idValidator("resource_version_seen");
/** @public */ export function createResourceVersionValidator(type) {
    return T.object({
        id: resourceIdValidator,
        typeName: T.literal("resource_version_seen"),
        type: T.literal(type),
        name: T.string,
        organizationId: T.number,
        scope: T.literalEnum("global", "organization"),
        maxVersionSeen: T.number,
        minVersionUsed: T.number,
        variantVersions: T.dict(T.string, T.object({
            maxVersionVariantSeen: T.number,
            minVersionVariantUsed: T.number
        }))
    });
}
/** @internal */ export function createResourceVersionSeenRecordType(resources) {
    return createRecordType("resource_version_seen", {
        migrations: undefined,
        scope: "document",
        validator: T.model("resource", T.union("type", mapObjectMapValues(resources, (type, { props, meta })=>createResourceVersionValidator(type))))
    }).withDefaultProperties(()=>({}));
}
